// extracted by mini-css-extract-plugin
export var phoneNumberInput = "_fx-0";